<template>
  <div>
    <div class="x-banner">
      <!-- banner -->
      <BANNER></BANNER>
      <!-- 二级导航 -->
      <NAVIGATION
        :data="navigationData"
        :currentPath="currentPath"
      ></NAVIGATION>
    </div>
    <div class="container-width location">
      当前位置:<router-link to="/">首页</router-link> >
      <router-link to="/ylts/home">医疗特色</router-link> >
      <router-link to="/ylts/zhuanke">国家临床重点专科</router-link>
    </div>
    <div class="container-width">
      <LIST :listData="list" :articlePath="articlePath"></LIST>
      <Pagination
        :pageCount="totalPages"
        :total="total"
        @togglePage="togglePage($event)"
      ></Pagination>
    </div>
  </div>
</template>

<script>
import service from "../../service/index";
import BANNER from "../../components/banner/ylts";
export default {
  name: "ZHUANKE",
  props: {},
  data() {
    return {
      navigationData: [
        {
          name: "科室介绍",
          path: "/ylts/home",
          width: "31%",
        },
        {
          name: "盛京名医",
          path: "/ylts/mingyi",
          width: "31%",
        },
        {
          name: "国家临床重点专科",
          path: "/ylts/zhuanke",
          width: "38%",
        },
        {
          name: "特色医疗中心",
          path: "/ylts/tese",
        },
        {
          name: "护理专业发展",
          path: "/ylts/huli",
        },
      ],
      currentPath: "/ylts/zhuanke",
      articlePath: "/ylts/zhuanke/article",

      pageIndex: 1,
      pageSize: window.screen.width < 720 ? 6 : 10,
      totalPages: 1,
      currentPage: 1,
      list: [],
      total: 0,
    };
  },
  created() {
    this.init();
  },
  components: { BANNER },
  methods: {
    init() {
      let parmes = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        isshow: 1,
      };
      service.getKeyList(parmes, (res) => {
        if (res.content.length) {
          res.content.map((item) => {
            item.releaseDate = item.releaseDate
              ? item.releaseDate.substr(0, 10)
              : "";
          });
        }
        this.totalPages = parseInt(res.totalPages) || 0;
        this.total = res.totalElements;
        this.list = res.content || [];
      });
    },

    togglePage(index) {
      this.pageIndex = index;
      this.init();
    },
  },
  mounted() {},
};
</script>

<style scoped lang="scss">
.title {
  font-size: 2rem;
  text-align: center;
  color: #333;
  margin-top: 12px;
}
.tab {
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-justify-content: center;
  justify-content: center;

  margin-top: 3px;
  .item {
    font-size: 1.125rem;
    border-bottom: 2px solid transparent;
    display: inline-block;
    padding: 6px;
    margin: 0 16px;
    position: relative;
    cursor: pointer;
  }
  .active {
    border-bottom-color: var(--primary-color);
    color: var(--primary-color);
  }
  .active:after {
    content: "";
    display: block;
    border-top: 6px solid var(--primary-color);
    border-left: 9px solid transparent;
    border-right: 9px solid transparent;
    width: 0;
    position: absolute;
    top: 100%;
    left: 50%;
    margin-left: -9px;
  }
}
.tab-content {
  .item {
    margin-top: 30px;
    .title {
      position: relative;
      display: -webkit-flex;
      display: flex;
      .name {
        font-size: 1.5rem;
        color: #333;
      }
      .line {
        position: absolute;
        top: 50%;
        left: 168px;
        right: 15px;
        border-top: 1px solid #0986c8;
        i {
          background-size: cover;
          font-size: 1rem;
          position: absolute;
          right: -12px;
          top: 50%;
          margin-top: -9px;
          color: #0986c8;
        }
      }
      .line:before,
      .line:after {
        content: "";
        width: 5px;
        height: 5px;
        border-radius: 50%;
        position: absolute;
        top: 50%;
        margin-top: -3.5px;
        background: #0986c8;
      }
      .line:before {
        left: 0px;
      }
      .line:after {
        right: 17px;
      }
    }
    .nr-block {
      .ks-list {
        grid-template-columns: repeat(6, 1fr);
        grid-row-gap: 15px;
        grid-column-gap: 10px;
        display: grid;
        margin-top: 30px;
        li {
          display: block;
          border: 1px solid #dddddd;
          line-height: 50px;
          overflow: hidden;
          height: 50px;
          box-sizing: border-box;
          display: -webkit-flex;
          display: flex;
          -webkit-box-pack: justify;
          -webkit-justify-content: space-between;
          -ms-flex-pack: justify;
          justify-content: space-between;
          -webkit-box-align: center;
          align-items: center;
          border-left: 1px solid#0986c8;
          -webkit-box-align: center;
          align-items: center;
          padding: 0 10px;
          a {
            color: #333;
            font-size: 0.9rem;
            opacity: 0.9;
            cursor: pointer;
          }
          i {
            color: #0986c8;
          }
        }
        .active {
          background: #0986c8;
          a {
            color: #fff;
          }
          i {
            color: #fff;
          }
        }
      }
      .inpatient-ward {
        margin-top: 20px;
        ul {
          grid-template-columns: repeat(2, 1fr);
          grid-row-gap: 20px;
          grid-column-gap: 100px;
          display: grid;
          li {
            a {
              color: #333;
              opacity: 0.9;
              cursor: pointer;
            }

            .ward-name {
              font-weight: bold;
            }
            .ward-detail {
              font-size: 0.75rem;
              margin-top: 10px;
              line-height: 25px;
              span {
                float: right;
                a {
                  color: #0986c8;
                }
              }
            }
          }
        }
        .correlation {
          color: #0986c8;
          height: 40px;
          font-size: 1rem;
        }
      }
    }
  }
}
</style>>
